import { useContext } from 'react'
import PropTypes from 'prop-types'

import { digObject } from '@domain-group/javascript-utils'

import {
  Button, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import useCreateAgencyPublicationsModal from './hooks/useCreateAgencyPublicationsModal'

import SelectPublications from './SelectPulications'

const CreateAgencyPublicationsModal = (props) => {
  const { callbacks, modalKey = 'CreateAgencyPublicationsModal', showModal } = props
  const { bulkCreateAgencyPublications, closeModal } = callbacks

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, modalKey, {})
  const { agencyPublication } = modalPayload

  const createAgencyPublicationPayload = useCreateAgencyPublicationsModal(agencyPublication)
  const {
    callbacks: {
      bulkCreateAgencyPublications: bulkCreateFn,
    },
    creating,
    hasSelectedPublications,
    selectedPublicationIds,
  } = createAgencyPublicationPayload

  const agencyPublicationPayload = {
    callbacks: {
      action: bulkCreateFn,
      afterAction: closeModal,
    },
    entityParams: { agencyId: agencyPublication.agency_id, publicationIds: selectedPublicationIds },
    toastText: 'Publications Assigned',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header callbacks={callbacks} title="Enable" titleSecondLine="Publications" />

      <SidebarModal.Content>
        <SelectPublications createAgencyPublicationPayload={createAgencyPublicationPayload} />
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!hasSelectedPublications}
          loading={creating}
          onClick={() => bulkCreateAgencyPublications(agencyPublicationPayload)}
          size="large"
        >
          {hasSelectedPublications ? 'Enable Publications' : 'Select a Publication'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

CreateAgencyPublicationsModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <CreateAgencyPublicationsModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
